export const assets = window.location.href.includes('localhost') ? './assets/': './assets/';
export const root = window.location.href.includes('localhost') ? '/': '/';